<template lang="pug">
  div
    v-layer
      v-image(v-if="images.bg" :config="configBg")
    v-layer(:config="{scaleX:0.9, scaleY:0.9, x:32, y:32}")
      v-image(v-if="images.leg" :config="configLeg")
      v-image(v-if="images.head" :config="configHead")
      v-image(v-if="images.body" :config="configBody")
      v-image(v-if="images.leftArm" :config="configLeftArm")
      v-image(v-if="images.rightArm" :config="configRightArm")
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      images: {
        head: null,
        body: null,
        leftArm: null,
        rightArm: null,
        leg: null,
        bg: null
      }
    };
  },
  created() {
    Object.keys(this.images).forEach(key => {
      if (!this.magrobo[key]) return;
      const image = new Image();
      image.onload = () => {
        this.images[key] = image;
      };
      image.src =
        `images/magrobo/${key}-${this.magrobo[key]}` +
        (key === "bg" ? "@2x.jpg" : ".png");
    });
  },
  watch: {
    images: {
      handler() {
        setTimeout(() => {
          this.$emit("update");
        }, 200);
      },
      deep: true
    }
  },
  computed: {
    ...mapState(["magrobo"]),
    configHead() {
      const id = this.magrobo.head;
      let config = {
        image: this.images.head
      };
      switch (id) {
        case 2:
          config.width = 400 * 0.4;
          config.height = 350 * 0.4;
          config.x = 600 * 0.4;
          config.y = 0 * 0.4;
          break;
        default:
          config.width = 400 * 0.4;
          config.height = 320 * 0.4;
          config.x = 600 * 0.4;
          config.y = 80 * 0.4;
      }
      return config;
    },
    configBody() {
      const config = {
        width: 192,
        height: 280,
        x: 224,
        y: 100,
        image: this.images.body
      };
      return config;
    },
    configLeftArm() {
      const id = this.magrobo.leftArm;
      let config = {
        image: this.images.leftArm
      };
      switch (id) {
        case 1:
          config.width = 520 * 0.4;
          config.height = 720 * 0.4;
          config.x = 940 * 0.4;
          config.y = 190 * 0.4;
          break;
        case 2:
          config.width = 410 * 0.4;
          config.height = 650 * 0.4;
          config.x = 900 * 0.4;
          config.y = 190 * 0.4;
          break;
        case 3:
          config.width = 550 * 0.4;
          config.height = 840 * 0.4;
          config.x = 760 * 0.4;
          config.y = 190 * 0.4;
          break;
        case 4:
          config.width = 430 * 0.4;
          config.height = 650 * 0.4;
          config.x = 880 * 0.4;
          config.y = 190 * 0.4;
          break;
      }
      return config;
    },
    configRightArm() {
      const id = this.magrobo.rightArm;
      let config = {
        image: this.images.rightArm
      };
      switch (id) {
        case 1:
          config.width = 360 * 0.4;
          config.height = 720 * 0.4;
          config.x = 300 * 0.4;
          config.y = 190 * 0.4;
          break;
        case 2:
          config.width = 570 * 0.4;
          config.height = 600 * 0.4;
          config.x = 150 * 0.4;
          config.y = 0 * 0.4;
          break;
        case 3:
          config.width = 360 * 0.4;
          config.height = 650 * 0.4;
          config.x = 300 * 0.4;
          config.y = 190 * 0.4;
          break;
        case 4:
          config.width = 640 * 0.4;
          config.height = 470 * 0.4;
          config.x = 80 * 0.4;
          config.y = 170 * 0.4;
          break;
      }
      return config;
    },
    configLeg() {
      const config = {
        width: 920 * 0.4,
        height: 940 * 0.4,
        x: 340 * 0.4,
        y: 620 * 0.4,
        image: this.images.leg
      };
      return config;
    },
    configBg() {
      const config = {
        width: 640,
        height: 640,
        x: 0,
        y: 0,
        image: this.images.bg
      };
      return config;
    }
  }
};
</script>
